import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=bd4c2688&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=bd4c2688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4c2688",
  null
  
)

export default component.exports